import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import './../genFields.css';
import HelpButton from '../../richButtons/helpButton';

const optionClass = options => `col-xs-${Math.floor(12 / options.length)}`;

const RadioField = ({ input, options, placeholder, intl, hideErrors, horizontal, helpText, selectedValue, meta: { touched, error, warning } }) => (
    <div className="radio-field radio-field-vertical-radios form-group no-select">
        <div className="row">
            <div className={horizontal ? 'col-xs-12' : 'col-md-9 col-sm-8 col-xs-12'}>
                <div className="radio-label-wrapper">
                    <div
                        className="label-container"
                        dangerouslySetInnerHTML={{
                            __html: typeof placeholder === 'string' ? placeholder : intl.formatHTMLMessage(placeholder, placeholder.values)
                        }}
                    />
                    {helpText && <HelpButton text={helpText} />}
                </div>
            </div>
            <div className={horizontal ? 'col-xs-12' : 'col-md-3 col-sm-4 col-xs-8'}>
                {options.map((option, i) => {
                    return (
                        <div className={horizontal ? 'col-xs-12' : optionClass(options)} key={i}>
                            <label>
                                {selectedValue === undefined ? (
                                    <input type="radio" {...input} value={option.value} key={`${i}-on`} />
                                ) : (
                                    <input
                                        type="radio"
                                        {...input}
                                        value={option.value}
                                        key={`${i}-off`}
                                        checked={selectedValue.toString() === option.value.toString()}
                                    />
                                )}
                                {option.label}
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
        {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
    </div>
);

RadioField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {},
    options: [],
    helpText: ''
};

RadioField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object,
    options: PropTypes.array.isRequired,
    id: PropTypes.string,
    helpText: PropTypes.string
};

export default injectIntl(RadioField);



// WEBPACK FOOTER //
// ./src/components/genFields/radio/index.jsx